import dayjs from "dayjs";

// plugins
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import updateLocale from "dayjs/plugin/updateLocale";
import customParseFormat from "dayjs/plugin/customParseFormat";

// locale
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';

// extend (순서 중요)
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);

const APP_LOCALE = (process.env.REACT_APP_LANGUAGE || 'ko').toLowerCase();

dayjs.locale(APP_LOCALE);

// 중국어 weekStart 강제
if (APP_LOCALE === 'zh-cn') {
  dayjs.updateLocale('zh-cn', {
    weekStart: 1
  });
}

// timezone
dayjs.tz.setDefault(process.env.REACT_APP_TIMEZONE || "Asia/Shanghai");

export default dayjs;